

import { showLoadingToast, closeToast, showToast, showSuccessToast, showFailToast, } from 'vant';

import { createApp } from 'vue'
import App from '../App.vue'
const app = createApp(App);
app.config.meta = {}

/* app */
export function getApp() {
    return app
}

/* 全局加载层 */
app.config.globalProperties.$loading = (msg) => {
    showLoadingToast({
        duration: 0,
        message: msg || process.env.VUE_APP_LoadingText,
        forbidClick: true,
    });
}
/* 关闭全局加载层 */
app.config.globalProperties.$loadingClose = () => {
    closeToast();
}
/* 全局文本提示 */
app.config.globalProperties.$toast = (msg) => {
    showToast({
        duration: 3000,
        message: msg,
        position: 'bottom',
    });
}
/* 全局成功提示 */
app.config.globalProperties.$success = (msg) => {
    showSuccessToast({
        duration: 2400,
        message: msg,
    });
}
/* 全局失败提示 */
app.config.globalProperties.$fail = (msg) => {
    showFailToast({
        duration: 3000,
        message: msg,
    });
}

/* Array方法扩展 */
Array.prototype.remove = function (val) {
    var index = this.indexof(val);
    if (index > -1) {
        this.splice(index, 1);
    }
}
Array.prototype.clear = function () {
    this.splice(0, this.length);
}
Array.prototype.sum = function (action) {
    var sum = 0;
    this.forEach(item => {
        sum += action(item);
    });
    return sum;
}
Array.prototype.indexof = function (action) {
    for (var i = 0; i < this.length; i++) {
        if (action(this[i])) return i;
    }
    return -1;
}
Array.prototype.removeAll = function (action) {
    for (var i = this.length - 1; i >= 0; i--) {
        if (action(this[i])) this.splice(i, 1);
    }
}
Array.prototype.any = function (action) {
    var result = false
    this.forEach(element => {
        if (action(element)) {
            result = true
            return
        }
    });
    return result;
}
Array.prototype.findAll = function (action) {
    var list = []
    this.forEach(item => {
        if (action(item)) list.push(item)
    });
    return list;
}
Array.prototype.joins = function (action, join) {
    var str = ''
    if (!join) join = ','
    this.forEach(item => {
        str += action(item) + join
    });
    if (str) str = str.substring(0, str.length - join.length)
    return str;
}
Array.prototype.joinOne = function () {
    if (this.length > 0) return this[0]
    return ''
}
Array.prototype.groupBy = function (name) {
    const groups = {}
    this.forEach(item => {
        const group = JSON.stringify(item[name])
        groups[group] = groups[group] || []
        groups[group].push(item)
    })
    return Object.keys(groups).map(group => {
        return groups[group]
    })
}
Array.prototype.distinct = function () {
    const res = new Map();
    return this.filter(item => !res.has(item.Id) && res.set(item.Id, 1))
}
Array.prototype.distinct2 = function () {
    const res = new Map();
    return this.filter(item => !res.has(item) && res.set(item, 1))
}
